import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategorySection() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
          电影分类
        </h2>
        <Link
          to="/category/dongzuo"
          className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          全部分类
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-200/70 border border-background-300/40 hover:border-primary-500/40 hover:bg-background-200 transition-all duration-300"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
              <i className={`${cat.icon} text-xl md:text-2xl`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}